<ul class="list-group" *transloco="let t">
  <li class="list-group-item">{{ t(title) }}</li>
  <li *ngFor="let entry of entries"
      class="list-group-item list-group-item-action"
      (click)="action(entry.callback)">
    <fa-icon *ngIf="entry.icon" [icon]="entry.icon" [fixedWidth]="true"></fa-icon>
    <span [innerHTML]="t(entry.label)"></span>
  </li>
</ul>
